import { Directive, HostListener, Inject } from '@angular/core';
import * as screenfull from 'screenfull';

import { WINDOW } from '@page2flip/core';
import { DocumentService } from '../../core/services/document.service';
import { TrackingService } from "../../core/services/tracking.service";

@Directive({
  selector: '[p2fToggleFullscreen]',
  exportAs: 'fullscreen'
})
export class ToggleFullscreenDirective {

  private currentPageNumber: number;

  constructor(@Inject(WINDOW) private window: any,
              private doc: DocumentService,
              private trackingService: TrackingService) {
    doc.currentPageNumber.subscribe(pageNumber => this.currentPageNumber = pageNumber);
  }

  @HostListener('click')
  onClick() {
    if (screenfull.isEnabled) {
      screenfull.toggle();
    }

    // TODO: Capture browser-initiated fullscreen events (F11, via menu, etc). Probably this needs to be moved to event-listener.service.ts
    this.isFullscreen() ?
      this.trackingService.trackEvent({category: 'fullscreen', action: 'close', custom1: this.currentPageNumber.toString()}) :
      this.trackingService.trackEvent({category: 'fullscreen', action: 'open', custom1: this.currentPageNumber.toString()});
  }

  isFullscreen() {
    return this.window.innerHeight === this.window.screen.height;
  }

}
